export const CONTINUE_WATCHING = 'continue-watching';
export const SEARCH = 'search';

export const PAGE_TYPES = {
  DEFAULT: 'default',
  LIVE: 'live',
  PLAYLIST: 'playlist',
  SEARCH: 'search',
} as const;

export const STORAGE_TYPES = {
  LOCAL_STORAGE: 'localStorage',
  SESSION_STORAGE: 'sessionStorage',
} as const;
